import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-semibold focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[hsl(var(--brand-black))] text-white rounded-[999px] hover:scale-[1.03] hover:shadow-[0_10px_20px_rgba(0,0,0,0.2)]",
        destructive:
          "bg-[hsl(var(--state-error))] text-white rounded-[999px] hover:scale-[1.03] hover:shadow-[0_10px_20px_rgba(255,59,48,0.3)]",
        outline:
          "border-2 border-[hsl(var(--border-light))] bg-[hsl(var(--bg-card))] text-[hsl(var(--text-primary))] rounded-[999px] hover:border-[hsl(var(--accent-primary))] hover:bg-[hsl(var(--bg-input))]",
        secondary:
          "bg-transparent text-[hsl(var(--text-secondary))] rounded-[999px] hover:text-[hsl(var(--text-primary))] hover:bg-[rgba(0,0,0,0.05)]",
        ghost: "hover:bg-[hsl(var(--bg-input))] hover:text-[hsl(var(--text-primary))] rounded-[14px]",
        link: "text-[hsl(var(--accent-primary))] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-11 px-6 py-2",
        sm: "h-9 px-4 text-sm",
        lg: "h-14 px-8 text-base",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
